<div class="container">
    <!-- SignUp -->
    <div class=" signup">
        <div class="signup" style="border-radius:20px">
            <div class="wrapper">
                <div class="row">
                    <!-- Picture -->
                    <div class="btns">
                        <button class="close"
                            (click)="global.trackEvent('Exit-pop-up', 'guestuser-pop-up-close');closePopup();"><img
                                src="../../../assets/image/exit-popup/x.png" alt="close">
                        </button>
                    </div>
                    <div class=" col-lg col-md-6 col-12 picture d-flex flex-column align-items-center text-center ">
                        <img src="../../../assets/image/exit-popup/Group 2856.svg" alt="Playing Gitar" width="380px"
                            height="280px" (load)="global.trackEvent('Exit-pop-up', 'guestuser-pop-up-open')">
                        <form #form="ngForm" (ngSubmit)="submitNumber(form.value)">
                            <input type="number" placeholder="Phone Number" class="form-control" ngModel required mobile
                                name="email" />
                            <button class="btn" type="submit" [disabled]="!form.valid">
                                Submit Now!
                            </button>
                        </form>
                    </div>

                    <!-- Description -->
                    <div class="col-lg col-md-6 col-12 description d-flex flex-column">
                        <h1 class="title">
                            Not Convinced?
                            <br>
                            Have some questions?
                        </h1>
                        <h2 class="subtitle">Let us help you.</h2>
                        <p class="listed">
                            Just drop in your mobile number and we'll call you!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
